import { Icon } from '@widget/toolbox/components';
import { IconWrap, Wrap, Text } from './styles';

import type { FC } from 'react';
import type { IconProps } from '@widget/toolbox/components';

export type IconWithTextProps = {
  iconType?: IconProps['type'] | null;
  text?: string | null;
};

export const IconWithText: FC<IconWithTextProps> = ({ iconType, text }) => {
  if (!text && !iconType) {
    return null;
  }

  return (
    <Wrap>
      {iconType ? (
        <IconWrap>
          <Icon type={iconType} />
        </IconWrap>
      ) : null}
      {text ? <Text>{text}</Text> : null}
    </Wrap>
  );
};
